'use strict';

import Vue from 'vue';
import App from '@framework/baseApp';
import createStore from '@store/index';

import entry from '@client/page/mobile/view/entry/share/live/index.vue';
import directives from '@client/page/mobile/directives/index';
// const VueVideoPlayer = require('vue-video-player/dist/ssr');
// const hls = require('videojs-contrib-hls');

// Vue.use(hls);
// Vue.use(VueVideoPlayer);
Vue.use(directives);
export default new App({ entry, createStore }).bootstrap();